import {ssoText, useSsoLocale} from '../../../../../../../../resources/js/linkspot-ui';
import {AccountSettingsPanel} from '../account-settings-panel';
import {AccountSettingsId} from '@common/auth/ui/account-settings/account-settings-sidenav';
export function DangerZonePanel(){
 useSsoLocale();
return <AccountSettingsPanel id={AccountSettingsId.DeleteAccount} title={<>{ssoText("회원 탈퇴")}</>}><p style={{marginBottom:16}}>{ssoText("같은 LinkSpot 계정으로 본인 확인을 마친 뒤 최종 확인으로 진행합니다.")}</p><a href="/auth/account/delete" className="text-danger underline">{ssoText("회원 탈퇴 절차로 이동")}</a></AccountSettingsPanel>;}
